<script setup lang="ts">
useSeoMeta({
  title: "Veranstaltungstechnik Salzburg – Bühne, Ton & Licht mieten",
  ogTitle: "Veranstaltungstechnik Salzburg – Bühne, Ton & Licht mieten | Mody",
  description: "Professionelle Veranstaltungstechnik in Salzburg: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik – zuverlässig, erfahren, persönlich.",
  ogDescription: "Professionelle Veranstaltungstechnik in Salzburg: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik – zuverlässig, erfahren, persönlich.",
})

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Mody Veranstaltungstechnik",
  "url": "https://mody.at/veranstaltungstechnik-salzburg",
  "telephone": "+43 664 2247433",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Flachau",
    "postalCode": "5542",
    "addressRegion": "Salzburg",
    "addressCountry": "AT",
    "streetAddress": "Ennspark 193"
  },
  "areaServed": {
    "@type": "City",
    "name": "Salzburg"
  },
  "description": "Professionelle Veranstaltungstechnik in Salzburg – Bühne, Ton und Licht für Events jeder Größe."
}

useHead({
  script: [
    { type: 'application/ld+json', innerHTML: localBusinessJsonLd }
  ]
})

const offerings = [
  { icon: 'pi pi-volume-up', title: 'Beschallung', description: 'Professionelle PA-Anlagen für kleine Säle bis zu großen Outdoor-Bühnen. Klangtreu, druckvoll und auf die Venue abgestimmt.' },
  { icon: 'pi pi-sun', title: 'Lichttechnik', description: 'Von stimmungsvollem Ambientelicht bis zur kompletten Moving-Head-Show - wir setzen euer Event perfekt in Szene.' },
  { icon: 'pi pi-home', title: 'Bühne', description: 'Unser StageTruck und modulare Bühnensysteme für Outdoor- und Indoor-Events - schnell auf- und abgebaut, sicher und imposant.' }
]

const events = ['Firmenfeiern', 'Konzerte', 'Hochzeiten', 'Stadtfeste', 'Open-Air-Events', 'Maturabälle', 'Kabarett & Theater', 'Sportveranstaltungen', 'Vereinsfeste']
const places = ['Stadt Salzburg', 'Hallein', 'Tennengau', 'Golling', 'Pongau', 'St. Johann im Pongau', 'Bischofshofen', 'Radstadt', 'Flachau', 'Altenmarkt', 'Schladming', 'Lungau', 'Tamsweg', 'St. Michael im Lungau', 'Mauterndorf']
</script>

<template>
  <LandingRegionalEventLanding
    kicker="Salzburg & Umgebung"
    title="Veranstaltungstechnik Salzburg"
    hero-description="Professionelle Bühne, Ton & Licht für Events in der Stadt Salzburg und dem gesamten Salzburger Land – vom kleinen Firmenevent bis zum großen Open Air."
    intro-heading="Euer Partner für Events in Salzburg"
    :intro-paragraphs="[
      'Mody Veranstaltungstechnik beliefert seit über 25 Jahren Events im Salzburger Land – von der Altstadt Salzburg bis in den Pongau und Lungau. Ob Firmenfeier, Konzert, Hochzeit oder Open Air: Wir liefern das passende Equipment, bauen es auf und stehen euch während des Events zur Seite.',
      'Unser Lager in Flachau (Ennspark 193) liegt ideal, um Events in der Stadt Salzburg und der gesamten Region schnell und zuverlässig zu beliefern.'
    ]"
    offerings-heading="Was wir in Salzburg anbieten"
    :offerings="offerings"
    events-heading="Events, die wir in Salzburg betreuen"
    :events="events"
    service-heading="Unser Einzugsgebiet rund um Salzburg"
    service-description="Wir betreuen Events in der Stadt Salzburg und der gesamten Region – von der Altstadt bis in den Tennengau, Pongau und Lungau."
    :places="places"
    cta-heading="Jetzt Angebot für euer Salzburg-Event anfragen"
    cta-description="Kostenlos & unverbindlich. Wir melden uns schnell zurück mit einem individuellen Angebot."
  />
</template>
